// 1977 Series 1 Mexico Edition — GENERATED by pipeline-publish (2026-06-12)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/1977-series-1-mexico-edition.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "1977-series-1-mexico-edition",
//     name: "1977 Series 1 Mexico Edition",
//     shortName: "Series 1 Mexico Edition 1977",
//     year: 1977,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "1977",
//     totalCards: 67,
//     description: "Topps 1977 Series 1 Mexico Edition trading card set.",
//     color: "#888aa0",
//     accentColor: "#f0c040",
//     dataFile: "1977-series-1-mexico-edition",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [],
    cards: [
        { n: "1", name: "Luke Skywalker" },
        { n: "2", name: "Citripio y Artu Ditu" },
        { n: "3", name: "Artu Ditu el pequeño robot" },
        { n: "4", name: "Han Solo el pirata del espacio" },
        { n: "5", name: "La Princesa Lia Organa" },
        { n: "6", name: "Ben Obi-Wan Kenobi" },
        { n: "7", name: "El villano Darth Vader" },
        { n: "8", name: "Moff Tarkin" },
        { n: "9", name: "Los rebeldes defienden su nave" },
        { n: "10", name: "Capturan a la Princesa Lia" },
        { n: "11", name: "Los Jawas se llevan a Artu" },
        { n: "12", name: "Los robots se reúnen" },
        { n: "13", name: "Una venta de robots" },
        { n: "14", name: "Luke revisa su nuevo robot" },
        { n: "15", name: "A Artu Ditu lo dejan atrás" },
        { n: "16", name: "Los Jawas de Tatuin" },
        { n: "17", name: "Lord Vader amenaza a Lia" },
        { n: "18", name: "Artu Ditu ha desaparecido" },
        { n: "19", name: "En busca del pequeño robot" },
        { n: "20", name: "En persecución de Luke" },
        { n: "21", name: "Los feroces colmilludos" },
        { n: "22", name: "Ben Kenobi los rescata" },
        { n: "23", name: "Citripio esta herido" },
        { n: "24", name: "En persecución de los robots" },
        { n: "25", name: "Luke va a salvar a su familia" },
        { n: "26", name: "Luke se horroriza" },
        { n: "27", name: "Luke repara a citripio" },
        { n: "28", name: "Luke acepta seguir a Ben" },
        { n: "29", name: "Los guardias los detienen" },
        { n: "30", name: "Han en su nave" },
        { n: "31", name: "La Estrella de la Muerte" },
        { n: "32", name: "Los guardias de Lord Vader" },
        { n: "33", name: "Citripio en la sala de control" },
        { n: "34", name: "Citripio distrae a los guardias" },
        { n: "35", name: "Luke y Han se disfrazan" },
        { n: "36", name: "El arma láser estalla" },
        { n: "37", name: "En el laberinto" },
        { n: "38", name: "Luke y han entre los escombros" },
        { n: "39", name: "Una defensa heroica" },
        { n: "40", name: "Los robots salvan a sus amos" },
        { n: "41", name: "Al borde del abismo" },
        { n: "42", name: "Los Guardias Atacan" },
        { n: "43", name: "Luke Y Lia a punto de saltar" },
        { n: "44", name: "Han Y Chewbacca disparan" },
        { n: "45", name: "Los sables de luz" },
        { n: "46", name: "Ben se defiende" },
        { n: "47", name: "Luke se prepara para combatir" },
        { n: "48", name: "Artu Ditu aborda la nave" },
        { n: "49", name: "Los rebeldes observan el ataque" },
        { n: "50", name: "Los lideres rebeldes" },
        { n: "51", name: "Citripio y la Princesa Lia" },
        { n: "52", name: "Quien ganara la batalla final" },
        { n: "53", name: "El feroz combate espacial" },
        { n: "54", name: "Recompensan a los vencedores" },
        { n: "55", name: "Han, Chewbacca y Luke" },
        { n: "56", name: "Un gran día" },
        { n: "57", name: "Mark Hamill es Luke Skywalker" },
        { n: "58", name: "Harrison Ford es Han Solo" },
        { n: "59", name: "Alec Guiness es Ben Kenobi" },
        { n: "60", name: "Peter Cushing es Moff Tarkin" },
        { n: "61", name: "Mark en la sala de controles" },
        { n: "62", name: "Soldados de Lord Vader" },
        { n: "63", name: "Que La Fuerza Te Acompane" },
        { n: "64", name: "El gobernador del imperio" },
        { n: "65", name: "Carrie Fisher y Mark Hamill" },
        { n: "66", name: "Citripio el asombroso robot" },
    ],
  },
  {
    id: "promo",
    type: "insert",
    title: "PROMO",
    parallels: [],
    cards: [
        { n: "NNO", name: "Lyausa" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
